import { render, staticRenderFns } from "./TextColor.vue?vue&type=template&id=db4da650&scoped=true&"
import script from "./TextColor.vue?vue&type=script&lang=js&"
export * from "./TextColor.vue?vue&type=script&lang=js&"
import style0 from "./TextColor.vue?vue&type=style&index=0&id=db4da650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4da650",
  null
  
)

export default component.exports